// Define a interface para os dados de uma peça
export interface JewelryItem {
  id: string;
  name: string;
  description: string; // Descrição curta para cards
  fullDescription: string; // Descrição completa para página de detalhes
  material: string; // Material da peça
  size?: string; // Tamanho (opcional, apenas para anéis)
  weight: string;
  creationMethod: string;
  creator: string;
  collection?: string; // Coleção (opcional)
  images: string[]; // Array com os caminhos das imagens
  category: 'aneis' | string; // Categoria (pode expandir no futuro)
  order: number; // Ordem de lançamento/exibição
  releaseDate: string; // Data de lançamento
}

// Define a interface para os dados de uma coleção
export interface CollectionItem {
  id: string;
  name: string;
  description: string; // Descrição curta para cards
  fullDescription: string; // Descrição completa para página de detalhes
  content: string; // Conteúdo da coleção
  creator: string;
  images: string[]; // Array com os caminhos das imagens
  pieces: string[]; // IDs das peças que pertencem à coleção
  order: number; // Ordem de lançamento/exibição
  releaseDate: string; // Data de lançamento
}

// Centraliza os dados de todas as peças
export const jewelryDatabase: JewelryItem[] = [
  {
    id: 'anel-fenda-abismo',
    name: 'Anel Fenda do Abismo',
    description: 'Uma peça que representa o instante da ruptura entre o mundo terreno e o submundo...',
    fullDescription: 'O Anel Fenda do Abismo é uma peça que representa o instante da ruptura entre o mundo terreno e o submundo, simbolizando a violenta e irreversível separação de Perséfone de sua mãe, Deméter, e de sua vida na superfície. Inspirado pela narrativa mítica onde a Terra se abre para que Hades surja em sua carruagem, este anel expressa, por meio de formas orgânicas e fraturadas, a violência contida neste momento trágico, marcando o início de um ciclo de dor, transformação e renascimento.',
    material: 'Prata 950',
    size: 'Nº18',
    weight: '±17,9g',
    creationMethod: 'Esculpido à mão em cera',
    creator: 'Gustavo Bigelli',
    collection: 'Coleção Entre Mundos',
    images: [
      process.env.PUBLIC_URL + '/images/rings/fenda_abismo/1.jpg',
      process.env.PUBLIC_URL + '/images/rings/fenda_abismo/2.jpg',
      process.env.PUBLIC_URL + '/images/rings/fenda_abismo/3.jpg',
    ],
    category: 'aneis',
    order: 6,
    releaseDate: '26/06/2025'
  },
  {
    id: 'anel-sementes-destino',
    name: 'Anel Sementes do Destino',
    description: 'Representa o momento crucial em que Perséfone consome as sementes da romã...',
    fullDescription: 'O Anel Sementes do Destino representa o momento crucial em que Perséfone, já no submundo, consome as sementes da romã — selando simbolicamente seu destino ao se tornar rainha do Hades. Segundo o mito, comer o fruto do submundo a conecta para sempre àquele reino, o que traz à tona temas como destino, transformação e permanência cíclica.',
    material: 'Prata 950',
    size: 'Nº20',
    weight: '±14,3g',
    creationMethod: 'Esculpido à mão em cera',
    creator: 'Gustavo Bigelli',
    collection: 'Coleção Entre Mundos',
    images: [
      process.env.PUBLIC_URL + '/images/rings/sementes_destino/1.jpg',
      process.env.PUBLIC_URL + '/images/rings/sementes_destino/2.jpg',
      process.env.PUBLIC_URL + '/images/rings/sementes_destino/3.jpg',
    ],
    category: 'aneis',
    order: 5,
    releaseDate: '26/06/2025'
  },
  {
    id: 'anel-veu-limbo',
    name: 'Anel Véu do Limbo',
    description: 'Representa o limiar entre os dois mundos — o espaço de transição...',
    fullDescription: 'O Anel Véu do Limbo representa o limiar entre os dois mundos — o espaço de transição entre a superfície e o submundo, entre vida e morte, calor e frio, flor e sombra. É o estado suspenso de Perséfone, que passa a habitar dois reinos e a viver uma dualidade existencial. Este anel evoca o silêncio e a introspecção desse "entre-lugar", pois a partir do momento em que ela consome as sementes de romã, ela já não pertence mais só à superfície, mas também não pertence só ao submundo, ela tem um pé em cada um desses dois mundo.',
    material: 'Prata 950',
    size: 'Nº20',
    weight: '±19,2g',
    creationMethod: 'Esculpido à mão em cera',
    creator: 'Gustavo Bigelli',
    collection: 'Coleção Entre Mundos',
    images: [
      process.env.PUBLIC_URL + '/images/rings/veu_limbo/1.jpg',
      process.env.PUBLIC_URL + '/images/rings/veu_limbo/2.jpg',
      process.env.PUBLIC_URL + '/images/rings/veu_limbo/3.jpg',
    ],
    category: 'aneis',
    order: 4,
    releaseDate: '26/06/2025'
  },
  {
    id: 'anel-garra',
    name: 'Anel Garra',
    description: 'Inspirado pelas formas intrigantes e poderosas das garras...', // Curta
    fullDescription: 'Inspirado pelas formas intrigantes e poderosas das garras, o Anel Garra é um símbolo de determinação e sofisticação. Com uma curvatura texturizada, levando ao encontro entre as pontas das garras, este anel representa um toque sutil de mistério e aventura em sua essência.',
    material: 'Prata 950',
    size: 'Nº22',
    weight: '±14,3g',
    creationMethod: 'Esculpido à mão em cera.',
    creator: 'Gustavo Bigelli',
    images: [
      process.env.PUBLIC_URL + '/images/rings/garra/1.jpg',
      process.env.PUBLIC_URL + '/images/rings/garra/2.jpg',
      process.env.PUBLIC_URL + '/images/rings/garra/3.jpg',
    ],
    category: 'aneis',
    order: 3,
    releaseDate: '18/03/2024'
  },
  {
    id: 'anel-golem',
    name: 'Anel Golem',
    description: 'Inspirado pela lendária figura dos antigos guardiões de pedra...', // Curta
    fullDescription: 'Inspirado pela lendária figura dos antigos guardiões de pedra, o Anel Golem é uma fusão de artesanato requintado e mito ancestral. Cada linha e detalhe esculpido ecoa a imponência e a solidez da figura mítica que o inspirou. Permita que esta joia o conduza através dos véus do tempo, para um reino onde a realidade se entrelaça com a fantasia.',
    material: 'Prata 950',
    size: 'Nº22',
    weight: '±18,8g',
    creationMethod: 'Esculpido à mão em cera.',
    creator: 'Gustavo Bigelli',
    images: [
      process.env.PUBLIC_URL + '/images/rings/golem/1.jpg',
      process.env.PUBLIC_URL + '/images/rings/golem/2.jpg',
      process.env.PUBLIC_URL + '/images/rings/golem/3.jpg',
    ],
    category: 'aneis',
    order: 2,
    releaseDate: '13/03/2024'
  },
  {
    id: 'anel-thanatos',
    name: 'Anel Thanatos',
    description: 'Nascido sob o véu da escuridão, o Anel Thanatos carrega o nome do deus da morte...',
    fullDescription: 'Nascido sob o véu da escuridão, o Anel Thanatos carrega o nome do deus da morte. Sua face, marcada por traços severos, evoca a máscara do silêncio eterno, onde todo destino encontra repouso. Assim como Thanatos guiava as almas ao descanso inevitável, este anel traz consigo o peso da finitude e a beleza sombria do ciclo que se encerra. Uma joia que ressoa com o mistério da noite e a memória daqueles que cruzaram o limiar entre vida e morte.',
    material: 'Prata 950',
    size: 'Nº22',
    weight: '±15,6g',
    creationMethod: 'Esculpido à mão em cera.',
    creator: 'Gustavo Bigelli',
    images: [
      process.env.PUBLIC_URL + '/images/rings/thanatos/1.jpg',
      process.env.PUBLIC_URL + '/images/rings/thanatos/2.jpg',
    ],
    category: 'aneis',
    order: 8,
    releaseDate: '18/09/2025'
  },
  {
    id: 'anel-rocha',
    name: 'Anel Rocha',
    description: 'Inspirado pelas grandiosas formações rochosas que contam histórias...', // Curta
    fullDescription: 'Inspirado pelas grandiosas formações rochosas que contam histórias de tempos imemoriais, o Anel Rocha é uma manifestação tangível de elegância robusta, elaborado com um cuidado meticuloso e esculpido à mão; é um tributo à durabilidade e à eternidade, concebido para resistir ao teste do tempo. O peso substancial deste anel é um lembrete tangível de sua presença marcante e da resiliência intrínseca às rochas que inspiraram sua criação.',
    material: 'Prata 950',
    size: 'Nº21',
    weight: '±20,5g',
    creationMethod: 'Esculpido à mão em cera.',
    creator: 'Gustavo Bigelli',
    images: [
      process.env.PUBLIC_URL + '/images/rings/rocha/1.jpg',
      process.env.PUBLIC_URL + '/images/rings/rocha/2.jpg',
      process.env.PUBLIC_URL + '/images/rings/rocha/3.jpg',
      process.env.PUBLIC_URL + '/images/rings/rocha/4.jpg',
    ],
    category: 'aneis',
    order: 1,
    releaseDate: '06/02/2024'
  }
];

// Centraliza os dados de todas as coleções
export const collectionsDatabase: CollectionItem[] = [
  {
    id: 'colecao-entre-mundos',
    name: 'Coleção Entre Mundos',
    description: 'A travessia simbólica entre luz e sombra, morte e renascimento...',
    fullDescription: 'A coleção intitulada Entre Mundos representa a travessia simbólica entre luz e sombra, morte e renascimento, expressando visualmente a narrativa mitológica do rapto de Perséfone sob uma ótica contemporânea e emocional. Composta pelas peças Anel Fenda do Abismo, Anel Sementes do Destino e Anel Véu do Limbo, a coleção explora os contrastes entre os reinos de Hades e Deméter, evocando os ciclos inevitáveis de transformação e dualidade existencial que regem a condição humana. Cada joia atua como um artefato poético, fundindo formas orgânicas e texturas brutas com simbolismos profundos, voltados a um público que busca mais do que adornos — deseja carregar fragmentos de histórias, emoções e símbolos atemporais em sua estética pessoal.',
    content: '3 anéis',
    creator: 'Gustavo Bigelli',
    images: [
      process.env.PUBLIC_URL + '/images/collections/entre_mundos/1.jpg',
      process.env.PUBLIC_URL + '/images/collections/entre_mundos/2.jpg',
    ],
    pieces: ['anel-fenda-abismo', 'anel-sementes-destino', 'anel-veu-limbo'],
    order: 7,
    releaseDate: '26/06/2025'
  }
];

// Função auxiliar para buscar uma peça pelo ID (usada em PieceDetail)
export const findJewelryById = (id: string): JewelryItem | undefined => {
  return jewelryDatabase.find(item => item.id === id);
};

// Função auxiliar para buscar uma coleção pelo ID
export const findCollectionById = (id: string): CollectionItem | undefined => {
  return collectionsDatabase.find(item => item.id === id);
};

// Função para obter peças de uma coleção
export const getPiecesByCollection = (collectionId: string): JewelryItem[] => {
  const collection = findCollectionById(collectionId);
  if (!collection) return [];
  
  return collection.pieces.map(pieceId => findJewelryById(pieceId)).filter(Boolean) as JewelryItem[];
};

